import { useEffect } from "react";

// Handle Mobile Viewport when Virtual keyboard active
export const useViewportHeight = () => {
  useEffect(() => {
    const updateVH = () => {
      const vh = (window.visualViewport?.height ?? window.innerHeight) * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    updateVH();
    window.visualViewport?.addEventListener("resize", updateVH);
    window.visualViewport?.addEventListener("scroll", updateVH);
    window.addEventListener("resize", updateVH);

    return () => {
      window.visualViewport?.removeEventListener("resize", updateVH);
      window.visualViewport?.removeEventListener("scroll", updateVH);
      window.removeEventListener("resize", updateVH);
    };
  }, []);
};